"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButton = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var core_1 = require("@emotion/core");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var foundation_1 = require("../../theme/foundation");

var theme_1 = require("../../theme");

exports.ToggleButton = utils_2.forwardRef(function ToggleButton(props, ref) {
  var label = props.label,
      onClick = props.onClick,
      isSelected = props.isSelected;

  var _a = React.useState(isSelected),
      selected = _a[0],
      setSelected = _a[1];

  var sizes = theme_1.useTheme().sizes;
  var container = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\theight: 1.438em;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: flex-start;\n\t"], ["\n\t\theight: 1.438em;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: flex-start;\n\t"])));
  var labelCss = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\tposition: relative;\n\n\t\tfont-family: Mont, sans-serif;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tfont-size: 0.875em;\n\t\tline-height: 1.125em;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\tcolor: ", ";\n\n\t\t/* Inside Auto Layout */\n\n\t\tflex: none;\n\t\torder: 1;\n\t\talign-self: center;\n\t\tflex-grow: 0;\n\t\tmargin: 0px 0.5em;\n\t"], ["\n\t\tposition: relative;\n\n\t\tfont-family: Mont, sans-serif;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tfont-size: 0.875em;\n\t\tline-height: 1.125em;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\tcolor: ", ";\n\n\t\t/* Inside Auto Layout */\n\n\t\tflex: none;\n\t\torder: 1;\n\t\talign-self: center;\n\t\tflex-grow: 0;\n\t\tmargin: 0px 0.5em;\n\t"])), foundation_1.colors.secondary.grey);
  var option = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\tposition: relative;\n\t\twidth: 2em;\n\t\theight: 1em;\n\t\tleft: 0px;\n\t\ttop: 0.31em;\n\t\tbackground: ", ";\n\t\tborder-radius: ", ";\n\t"], ["\n\t\tposition: relative;\n\t\twidth: 2em;\n\t\theight: 1em;\n\t\tleft: 0px;\n\t\ttop: 0.31em;\n\t\tbackground: ", ";\n\t\tborder-radius: ", ";\n\t"])), foundation_1.colors.secondary.mediumGrey, sizes['8']);
  var optionCircle = core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\tposition: absolute;\n\t\twidth: 0.75em;\n\t\theight: 0.75em;\n\t\tleft: 2px;\n\t\ttop: 2px;\n\t\tbackground: ", ";\n\t\tborder-radius: ", ";\n\t"], ["\n\t\tposition: absolute;\n\t\twidth: 0.75em;\n\t\theight: 0.75em;\n\t\tleft: 2px;\n\t\ttop: 2px;\n\t\tbackground: ", ";\n\t\tborder-radius: ", ";\n\t"])), foundation_1.colors.white, sizes['8']);
  var selectedOption = core_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t\tposition: relative;\n\t\twidth: 2em;\n\t\theight: 1em;\n\t\tleft: 0;\n\t\ttop: 0.31em;\n\n\t\tbackground: ", ";\n\t\tborder-radius: ", ";\n\t"], ["\n\t\tposition: relative;\n\t\twidth: 2em;\n\t\theight: 1em;\n\t\tleft: 0;\n\t\ttop: 0.31em;\n\n\t\tbackground: ", ";\n\t\tborder-radius: ", ";\n\t"])), foundation_1.colors.status.success, sizes['8']);
  var selectedOptionCircle = core_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t\tposition: absolute;\n\t\twidth: 0.75em;\n\t\theight: 0.75em;\n\t\tleft: 1.125em;\n\t\ttop: 2px;\n\n\t\tbackground: ", ";\n\t\tborder-radius: ", ";\n\t"], ["\n\t\tposition: absolute;\n\t\twidth: 0.75em;\n\t\theight: 0.75em;\n\t\tleft: 1.125em;\n\t\ttop: 2px;\n\n\t\tbackground: ", ";\n\t\tborder-radius: ", ";\n\t"])), foundation_1.colors.white, sizes['8']);

  var onClickAction = function onClickAction() {
    setSelected(!selected);
    onClick();
  };

  return (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: container
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    onClick: onClickAction
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    css: selected ? selectedOption : option
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    css: selected ? selectedOptionCircle : optionCircle
  }))), (0, _core.jsx)(lseds_1.lseds.div, {
    css: labelCss
  }, label));
});

if (utils_1.isDev) {
  exports.ToggleButton.displayName = 'ToggleButton';
}

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;